import { render } from "./_MobileNavigation.vue?vue&type=template&id=65d38cfd&scoped=true&lang=en"
import script from "./_MobileNavigation.vue?vue&type=script&lang=js"
export * from "./_MobileNavigation.vue?vue&type=script&lang=js"

import "./_MobileNavigation.vue?vue&type=style&index=0&id=65d38cfd&lang=scss&scoped=true"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d38cfd"]])

export default __exports__